module.exports = "<svg>\n  <g id=\"linkLayer\"></g>\n  <g id=\"nodeLayer\"></g>\n</svg>\n";


//////////////////
// WEBPACK FOOTER
// ./statsTab/template.html
// module id = 24
// module chunks = 0